import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { removeSnackbar } from 'actions/notifications.actions';
import { notificationsSelector } from 'reducers/notifications.reducer';

export const Notifier: React.FC<WithSnackbarProps> = (props) => {
  const { list } = useSelector(notificationsSelector);
  const dispatch = useDispatch();
  const [displayed, setDisplayed] = useState<(string | number)[]>([]);
  const storeDisplayed = (id: string | number) =>
    setDisplayed([...displayed, id]);
  const removeDisplayed = (id: string | number) =>
    setDisplayed(displayed.filter((key) => id !== key));

  useEffect(() => {
    const { closeSnackbar, enqueueSnackbar } = props;
    list.forEach(({ key, message, options = {}, dismissed = false }: any) => {
      if (dismissed) {
        closeSnackbar(key);
        return;
      }
      // Do nothing if snackbar is already displayed
      if (displayed.includes(key)) return;
      // Display snackbar using notistack
      enqueueSnackbar(message, {
        key,
        ...options,
        onClose: (
          event: React.SyntheticEvent<any>,
          reason: string,
          key: string | number,
        ) => {
          if (options.onClose) {
            options.onClose(event, reason, key);
          }
        },
        onExited: (event: React.SyntheticEvent<any>, key: string | number) => {
          dispatch(removeSnackbar(key));
          removeDisplayed(key);
        },
      });
      // Keep track of snackbars that we've displayed
      storeDisplayed(key);
    });
  });

  return null;
};

export default withSnackbar(Notifier);
